import PropTypes from 'prop-types';
import React, {
  useCallback,
} from 'react';

import Button           from '@mui/material/Button';
import Stack            from '@mui/material/Stack';
import Grid             from '@mui/material/Grid';

import EmailIcon            from '@mui/icons-material/Email';
import TwitterIcon          from '@mui/icons-material/Twitter';
import FacebookOutlinedIcon from '@mui/icons-material/FacebookOutlined';
import LinkedinIcon         from '@mui/icons-material/LinkedIn';

import { useSnackbar }  from 'notistack';

function GenericSocialShare({ title }) {
  const { enqueueSnackbar } = useSnackbar();

  const notify = useCallback((variant, message) => {
    const opts = {
      variant,
      autoHideDuration: 6000,
      anchorOrigin:     {
        vertical:   'top',
        horizontal: 'right',
      },
    };

    enqueueSnackbar(message, opts);
  }, []);

  function onEmail() {
    const subject = encodeURIComponent(title);
    const body    = encodeURIComponent(document.URL);

    window.open(`mailto:?subject=${subject}&body=${body}`);
    return false;
  }

  function onTweet() {
    const text = encodeURIComponent(`${title}: ${document.URL}`);
    window.open(`https://twitter.com/intent/tweet?text=${text}`, 'popup', 'width=600,height=400');
    return false;
  }

  function onFBPost() {
    const url = encodeURIComponent(document.URL);

    window.open(`https://www.facebook.com/sharer/sharer.php?u=${url}`, 'popup', 'width=600,height=400');
    return false;
  }

  function onLinkedinShare() {
    const intitle = encodeURIComponent(title);
    const url     = encodeURIComponent(document.URL);

    window.open(`https://www.linkedin.com/shareArticle?mini=true&url=${url}&title=${intitle}`, 'popup', 'width=600,height=400');
    return false;
  }

  function onCopy() {
    navigator.clipboard.writeText(document.URL); // Only works in https
    notify('success', t('eos.landing_page.text.copied_succesfully'));
  }

  const socials = [
    { label: t('eos.landing_page.label.email_it'), action: onEmail, icon: <EmailIcon /> },
    { label: t('eos.landing_page.label.tweet_it'), action: onTweet, icon: <TwitterIcon /> },
    { label: t('eos.landing_page.label.post_it'), action: onFBPost, icon: <FacebookOutlinedIcon /> },
    { label: t('eos.landing_page.label.share_it'), action: onLinkedinShare, icon: <LinkedinIcon /> },
    { label: t('eos.landing_page.label.copy_it'), action: onCopy },
  ];

  return (
    <Stack>
      {
        socials.map((social) => (
          <Button
            key={social.label}
            onClick={social.action}
            sx={{
              textTransform: 'initial',
            }}
          >
            <Grid container spacing={2}>
              <Grid item xs={5} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                {social.icon}
              </Grid>
              <Grid
                item
                xs={7}
                sx={{
                  display: 'flex', alignItems: 'center', justifyContent: 'flex-start', color: 'common.black',
                }}
              >
                {social.label}
              </Grid>
            </Grid>
          </Button>
        ))
      }
    </Stack>
  );
}

GenericSocialShare.defaultProps = {
  title: '',
};

GenericSocialShare.propTypes = {
  title: PropTypes.string,
};

export default GenericSocialShare;
